import styled from 'styled-components'

export const NumberCard = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 240px;
  width: 100%;

  & > p {
    color: #A6FF00;
    font-size: 2.5rem;
    font-weight: 500;
    text-align: center;
  }

  & > small {
    color: #FFF;
    font-size: 0.75rem;
    text-align: center;
  }

  @media (max-width: 569px) {
    max-width: 144px;

    & > p {
      font-size: 1.5rem;
    }
  }
`

export const IconContainer = styled.figure`
  align-items: center;
  background: linear-gradient(180deg, #FFFFFF 0%, #D7F4EE 100%);
  border-radius: 50%;
  box-shadow: 0px 10px 20px 0px #00000040;
  display: flex;
  min-height: 72px;
  justify-content: center;
  padding: 16px;
  min-width: 72px;
`
